import React from "react";
import HoverButton from "../buttons/HoverButton";

export default function DeletePopup(props) {

    return (
        <div className="grid-x align-center">
            <div className="cell text-center">
                <h3 className='text-center mar-bot-10'>Delete Confirmation</h3>
                <p className='popup__text'>Are you sure do want to cancel invitation to {props.email}?</p>
                <div className="medium-text-center text-right">
                    <HoverButton className="mar-right-10" onClick={props.onCancel}>No</HoverButton>
                    <HoverButton onClick={props.onDelete}>Yes</HoverButton>
                </div>
            </div>
        </div>
    )
}